module.exports = __webpack_public_path__ + "static/img/flowers.cfd74a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flowers.png
// module id = QWkC
// module chunks = 0